module.exports = __webpack_public_path__ + "static/media/white-print.5a844e7e.svg";